/**
 * @generated SignedSource<<df1174cc15a058925e75406b6d0ec4e2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type async_softwareReleasesLaunchCard_AsyncVersionContributors$data = {
  readonly contributors: {
    readonly edges: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"versionContributors_softwareReleasesLaunchCard">;
    } | null | undefined>;
  };
  readonly " $fragmentType": "async_softwareReleasesLaunchCard_AsyncVersionContributors";
};
export type async_softwareReleasesLaunchCard_AsyncVersionContributors$key = {
  readonly " $data"?: async_softwareReleasesLaunchCard_AsyncVersionContributors$data;
  readonly " $fragmentSpreads": FragmentRefs<"async_softwareReleasesLaunchCard_AsyncVersionContributors">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "async_softwareReleasesLaunchCard_AsyncVersionContributors",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraVersionContributorConnection",
        "kind": "LinkedField",
        "name": "contributors",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "concreteType": "JiraVersionContributorEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "versionContributors_softwareReleasesLaunchCard"
                }
              ]
            },
            "action": "THROW",
            "path": "contributors.edges"
          }
        ]
      },
      "action": "THROW",
      "path": "contributors"
    }
  ],
  "type": "JiraVersion"
};

(node as any).hash = "1c2f7736ef0703bba0e1b3081509e3ee";

export default node;
